import { render, staticRenderFns } from "./CheckboxAnswer.vue?vue&type=template&id=54d6bf9d&scoped=true"
import script from "./CheckboxAnswer.vue?vue&type=script&lang=js"
export * from "./CheckboxAnswer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6bf9d",
  null
  
)

export default component.exports